
<script>
import moment from 'moment'
import AviaticketsControl from './Control.vue'
import AviaticketsTarrifs from './Tarrifs.vue'
import {
  nToWord,
  formatMinutesToHours
} from '@/utils/helpers'
import arrowDownIcon from '@/assets/images/icons/arrow-down.svg?inline'
import arrivalIcon from '@/assets/images/icons/arrival.svg?inline'
import departureIcon from '@/assets/images/icons/departure.svg?inline'

export default {
  name: 'aviatickets',
  components: {
    AviaticketsControl,
    AviaticketsTarrifs,
    arrowDownIcon,
    arrivalIcon,
    departureIcon
  },
  props: {
    flightIndex: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    showAll: false,
  }),
  computed: {
    getFlight() {
      return this.$store.getters['cart/getFlight'](this.flightIndex)
    },
    filteredCollection() {
      return this.showAll
        ? this.getFlight.collection
        : this.getFlight.collection.filter(flight => flight.id === this.getFlight.current.id)
    }
  },
  created() {},
  methods: {
    nToSegments: n => nToWord(n, ['пересадка', 'пересадки', 'пересадок']),
    formatMinutesToHours: minutes => formatMinutesToHours(minutes),
    formatTime: time => moment.unix(time).format('HH:MM'),
    formatDate: date => moment.unix(date).format('DD.MM.YYYY'),
    showSegments(aviaticketIndex, directionIndex) {
      const currentState = this.$store.getters['cart/getServiceField'](
        `flights.${this.flightIndex}.aviatickets.collection.${aviaticketIndex}.directions.${directionIndex}.showSegments`
      )

      this.$store.commit('cart/updateServiceField', {
        target: `flights.${this.flightIndex}.aviatickets.collection.${aviaticketIndex}.directions.${directionIndex}.showSegments`,
        value: !currentState
      })
    },
  }
}
</script>

<template>
  <div class="cart__aviatickets">
    <div
      v-for="(aviaticket, aviaticketIndex) in filteredCollection"
      :key="aviaticket.id"
      class="cart__aviatickets--item"
    >
      <div
        class="cart__aviatickets--main cart__aviatickets-main"
        :class="{ 'cart__aviatickets-main--show-tarrifs': aviaticket.showTarrifs }"
      >
        <div
          v-for="(direction, directionIndex) in aviaticket.directions"
          :key="directionIndex"
          class="cart__aviatickets-main--wrapper"
        >
          <div class="cart__aviatickets-main--header cart__aviatickets-header">
            <h3>
              {{ direction.info.cityFrom }}
              -
              {{ direction.info.cityTo }}
            </h3>
            <img
              :src="`https://pics.avs.io/80/40/${aviaticket.validatingCarrier.code}@2x.png`"
              alt=""
              class="cart__aviatickets-header--validating-carrier-logo"
            >
            <p class="cart__aviatickets-header--segments-counter">
              {{ direction.segments.length - 1 }}
              {{ nToSegments(direction.segments.length - 1) }}
            </p>
            <div
              class="cart__aviatickets-header--show-segments"
              @click="showSegments(aviaticketIndex, directionIndex)"
            >
              <arrowDownIcon
                fill="#000000"
              />
            </div>
          </div>
          <div class="cart__aviatickets--routs cart__aviatickets-routs">
            <div class="cart__aviatickets-routs--item">
              <div class="cart__aviatickets-routs--info">
                <div class="cart__aviatickets-routs--date">
                  <h3>{{ direction.info.startTime }}</h3>
                  <p>{{ direction.info.startDate }}</p>
                </div>
                <div class="cart__aviatickets-routs--flight-info">
                  <div class="cart__aviatickets-routs--icons">
                    <arrivalIcon
                      fill="#ABABAB"
                    />
                    <departureIcon
                      fill="#ABABAB"
                    />
                  </div>
                  <div
                    class="cart__aviatickets-routs--lines"
                    :class="{
                      'cart__aviatickets-routs--lines-transfer': direction.segments.length > 1
                    }"
                  >
                    <div />
                    <div />
                    <div />
                  </div>
                  <div class="cart__aviatickets-routs--flight-data">
                    <p>{{ direction.info.airportFrom }}</p>
                    <p>Перелёт: {{ formatMinutesToHours(direction.duration) }}</p>
                    <p>{{ direction.info.airportTo }}</p>
                  </div>
                </div>
                <div class="cart__aviatickets-routs--date">
                  <h3>{{ direction.info.endTime }}</h3>
                  <p>{{ direction.info.endDate }}</p>
                </div>
              </div>
              <div
                v-if="direction.showSegments"
                class="cart__aviatickets-routs--segments"
              >
                <div
                  v-for="(segment, segmentIndex) in direction.segments"
                  :key="segmentIndex"
                >
                  <p
                    v-if="segment.waitingTime"
                    class="cart__aviatickets-segment--waiting"
                  >
                    <span>Ожидание:</span>
                    {{ formatMinutesToHours(segment.waitingTime) }}
                  </p>
                  <div class="cart__aviatickets-routs--segment cart__aviatickets-segment">
                    <div class="cart__aviatickets-segment--date">
                      <p>{{ formatTime(segment.departure.time) }}</p>
                      <span>В пути:</span>
                      <p>{{ formatTime(segment.arrival.time) }}</p>
                    </div>
                    <div class="cart__aviatickets-segment--line" />
                    <div class="cart__aviatickets-segment--route">
                      <p>
                        {{ segment.departure.city.slug }}
                        {{ segment.departure.airport.slug }}
                        {{ segment.departure.city.iataCode }}
                      </p>
                      <p>{{ formatMinutesToHours(segment.duration) }}</p>
                      <p>
                        {{ segment.arrival.city.slug }}
                        {{ segment.arrival.airport.slug }}
                        {{ segment.arrival.city.iataCode }}
                      </p>
                    </div>
                    <div class="cart__aviatickets-segment--carrier">
                      <img
                        :src="`https://pics.avs.io/40/40/${segment.operationCarrier.code}@2x.png`"
                        alt=""
                      >
                      <div>
                        <p>{{ segment.operationCarrier.name }}</p>
                        <p>{{ segment.operationCarrier.code }} {{ segment.carrierNumber }}</p>
                        <span>{{ segment.aircraftName }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <aviatickets-control
        v-if="!aviaticket.showTarrifs"
        :aviaticket="aviaticket"
        :aviaticket-index="aviaticketIndex"
        :flight-index="flightIndex"
      />
      <aviatickets-tarrifs
        v-if="aviaticket.showTarrifs"
        :aviaticket-id="aviaticket.id"
        :flight-index="flightIndex"
      />
    </div>
    <div class="cart__aviatickets-show-togglers">
      <b-button
        class="rex-button2"
        type="is-light"
        @click="showAll = !showAll"
      >
        {{ showAll ? 'Только выбранные' : 'Показать все' }}
      </b-button>
    </div>
  </div>
</template>
